module.exports = __webpack_public_path__ + "img/19.9bf9d07b.png";